<div class="container"
  [@hide]="(contextConfigOpened$ | async) ? 'collapse' : 'void'"
  cdkDragBoundary="body"
  cdkDrag>
  @if ((currentContext$ | async | typeOf) === 'object') {
    <div class="slider-container"
      >
      <!-- Display the context label only if a context is defined -->
      <span [@slide]="showSlider ? 'in' : 'out'"
        class="slider-text">
        {{ 'ACTIVE_CONTEXT' | translate:{context: (currentContext$ | async)?.name || ('CONTEXT_SESSION' | translate) } }}
        &nbsp;&nbsp;
      </span>
    </div>
  }
  <button mat-fab
    color="primary"
    [matMenuTriggerFor]="menu"
    #menuTrigger="matMenuTrigger"
    (mouseover)="showSlider = true"
    (mouseout)="showSlider = false">
    <mat-icon>tune</mat-icon>
  </button>
</div>

<mat-menu #menu="matMenu"
  xPosition="before">
  @if ((unselectedUserContexts$ | async | listFilter:'favorite':true); as contexts) {
    @for (userFilter of contexts | sort:false:'updatedAt' | slice:0:5; track userFilter) {
      <div>
        <button mat-menu-item
          (click)="loadSelectedContext(userFilter)">
          {{ userFilter.name }}
        </button>
      </div>
    }
    @if (contexts.length) {
      <mat-divider></mat-divider>
    }
  }
  @if ((currentContext$ | async | typeOf) === 'object') {
    <button
      mat-menu-item
      (click)="openEditContext()">
      <fa-icon icon="pencil-alt"
      [fixedWidth]="true"></fa-icon>
      {{"EDIT_CONTEXT" | translate}}
    </button>
  }
  <button mat-menu-item
    (click)="openCreateContext()">
    <fa-icon icon="plus"
    [fixedWidth]="true"></fa-icon>
  {{"CREATE_CONTEXT" | translate}}</button>
  @if ((unselectedUserContexts$ | async)?.length > 0 ) {
    <button
      mat-menu-item
      (click)="openManageContext()">
      <fa-icon icon="cog"
      [fixedWidth]="true"></fa-icon>
      {{"MANAGE_CONTEXT" | translate}}
    </button>
  }
</mat-menu>
